/**
 * Child Theme - Scripts
 * File: custom-javascript.js
 * Description: file Js principale para el tema Child, qui vengono inizializzati i moduli js.
 *
 */

import VideoModal from "./modules/video-modal";
import StickyAside from "./modules/sticky-aside";
import ScrollSpy from "./modules/scroll-spy";
import { initHeroSlider } from "./modules/init-hero-slider";
import { initCardSlider } from "./modules/init-card-slider";
import { initScrollReveal } from "./modules/scroll-reveal";
import { initAccordionScroll } from "./modules/accordion-scroll";
import { initScrollAnchor } from "./modules/scroll-to-anchor";

jQuery(document).ready(function ($) {
    console.log("Theme Child → DOM pronto 👍");

    // La navbar è sticky via CSS (#mainSiteHeader), nessun init JS necessario.

    // Inizializza la Sidebar sticky (solo se presente nella pagina)
    StickyAside.initialize("[data-sticky-aside]", "mainNavbar", "wpadminbar");

    // Inizializza lo Scroll Spy per i link della sidebar
    ScrollSpy.initialize("[data-aside-anchor]", "mainNavbar", "wpadminbar");

    // Inizializza lo slider Hero, attivato solo se necessario
    initHeroSlider();

    // Inizializza gli slider card Attivita / News
    initCardSlider();

    // Inizializza le animazioni allo scroll (Intersection Observer)
    initScrollReveal();

    // Inizializza lo scroll automatico all'apertura degli accordion Bootstrap
    initAccordionScroll();

    // Inizializza lo scroll corretto verso le ancore del menu
    initScrollAnchor();

    // Inizializza la Video Modal globale
    VideoModal.init();
});
